import React, { useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useGetIconsQuery } from 'src/api/v1/user-custom-items-ApiSlice';
import { fitSvgToContainer } from 'src/pages/PlannerPage/DeviceView/svgIconUtils';

type Icon = {
    id: number;
    icon_svg: string;
    color: string;
};

type IconPickerProps = {
    value?: Icon;
    onChange: (icon: Icon) => void;
};

export function IconPicker({ value, onChange }: IconPickerProps) {
    const { data: fetchedIcons, isLoading, isError } = useGetIconsQuery();

    useEffect(() => {
        if (
            fetchedIcons &&
            !isError &&
            !isLoading &&
            fetchedIcons.length > 0 &&
            value === undefined
        ) {
            onChange(fetchedIcons[0]);
        }
    }, [fetchedIcons, isError, isLoading, value, onChange]);

    if (!value) return null;

    return (
        <Autocomplete<Icon, false, true, false>
            options={fetchedIcons!}
            loading={isLoading}
            disableClearable
            value={value}
            isOptionEqualToValue={(option, val) => option.id === val.id}
            getOptionLabel={() => ''}
            onChange={(_, v) => {
                if (v) onChange(v);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        startAdornment:
                            value ? (
                                <div
                                    style={{ height: 30, width: 30 }}
                                    dangerouslySetInnerHTML={{
                                        __html: fitSvgToContainer(value.icon_svg),
                                    }}
                                />
                            ) : undefined,
                        endAdornment: params.InputProps.endAdornment,
                    }}
                />
            )}
            renderOption={(props, option) => {
                const { key, ...rest } = props;
                return (
                    <li {...rest} key={option.id}>
                        <div
                            style={{ height: 30, width: 30 }}
                            dangerouslySetInnerHTML={{
                                __html: fitSvgToContainer(option.icon_svg),
                            }}
                        />
                    </li>
                )
            }}
            ListboxProps={{
                sx: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    px: 1,
                    py: 1,
                    alignItems: 'flex-start',
                    maxHeight: 240,
                    overflowY: 'auto',
                    '& .MuiAutocomplete-option': {
                        minHeight: 'unset',
                        padding: 0,
                        backgroundColor: 'transparent !important',
                        '&:hover': {
                            backgroundColor: 'transparent !important',
                        },
                    },
                },
            }}
            sx={{
                flex: 1,
                '& input': { display: 'none' },
            }}
        />
    );
}